const STORAGE_KEY = 'schoolmeals_oauth_return_to';

/**
 * Before redirecting to Toddle, store where to return after callback (path + query).
 */
export function storeOAuthReturnPath(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(STORAGE_KEY, window.location.pathname + window.location.search);
}

/**
 * Build default post-login URL for a student.
 */
export function defaultPostAuthPath(studentId: string): string {
  return `/?studentId=${encodeURIComponent(studentId)}`;
}

/**
 * Returns a safe in-app path after OAuth, or default meals root.
 */
export function consumeOAuthReturnTo(expectedStudentId: string): string {
  if (typeof window === 'undefined') return defaultPostAuthPath(expectedStudentId);
  const raw = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  if (!raw) return defaultPostAuthPath(expectedStudentId);
  try {
    const u = new URL(raw, window.location.origin);
    const sid = u.searchParams.get('studentId');
    if (sid !== expectedStudentId) return defaultPostAuthPath(expectedStudentId);
    if (u.pathname === '/' || u.pathname === '/consents') {
      return `${u.pathname}${u.search}`;
    }
  } catch {
    /* ignore */
  }
  return defaultPostAuthPath(expectedStudentId);
}
